import React from 'react';
import DocumentIdProcessVerification from '../common/DocumentIdProcessVerification';

const IncomeVerification = () => {
  // HTML
  return <DocumentIdProcessVerification isMultiple={true} />;
};

export default IncomeVerification;
